// Canonical ESG framework codes. Mirrors the API's
// src/constants/frameworks.constants.js exactly. Treat as opaque
// case-sensitive strings everywhere except normalizeFramework().
export const ESG_FRAMEWORKS = [
  "JJ-Group",
  "SGX",
  "BURSA",
  "GRI",
  "TCFD",
  "IFRS-1",
  "IFRS-2",
];

export const JJ_GROUP_FRAMEWORK_CODE = "JJ-Group";

// Report/UI-only codes. UNIVERSAL means "no framework filter" /
// cross-framework report. CUSTOM is a virtual on custom disclosures.
// Neither is a valid value for Disclosure.framework.
export const SYNTHETIC_FRAMEWORKS = ["UNIVERSAL", "CUSTOM"];

export const ALL_VALID_FRAMEWORKS = [
  ...ESG_FRAMEWORKS,
  ...SYNTHETIC_FRAMEWORKS,
];

export const ESG_FRAMEWORK_SET = new Set(ESG_FRAMEWORKS);
export const SYNTHETIC_FRAMEWORK_SET = new Set(SYNTHETIC_FRAMEWORKS);

export const FRAMEWORK_CANONICAL_BY_LOWER = new Map(
  ESG_FRAMEWORKS.map((f) => [f.toLowerCase(), f]),
);

export const FRAMEWORK_ALIASES = {
  IFRS: ["IFRS-1", "IFRS-2"],
  "IFRS S1": ["IFRS-1"],
  "IFRS S2": ["IFRS-2"],
};
